import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/api';
import { useAuth } from '../services/AuthContext';

export default function Login() {
  const [form, setForm] = useState({ login: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(form.login, form.password);
      signIn(data.token, data.user);
      navigate('/planning');
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '32px 24px', gap: '20px' }}>
      <div style={{ width: 68, height: 68, borderRadius: '50%', background: 'var(--info-fond)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, marginBottom: 8 }}>
        📋
      </div>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: 22, fontWeight: 600 }}>Planning Technicien</h1>
        <p style={{ fontSize: 14, color: 'var(--texte-doux)', marginTop: 4 }}>Accès sécurisé à vos interventions</p>
      </div>
      <form onSubmit={handleSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div className="field">
          <div className="field-label">Identifiant</div>
          <input type="text" value={form.login} onChange={e => setForm(f => ({ ...f, login: e.target.value }))} placeholder="votre.identifiant" autoCapitalize="none" required />
        </div>
        <div className="field">
          <div className="field-label">Mot de passe</div>
          <input type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="••••••••" required />
        </div>
        {error && <div style={{ color: 'var(--danger-texte)', fontSize: 13, textAlign: 'center' }}>{error}</div>}
        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}